/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {GetSearchableModels200} from './schemas/get-searchable-models200';

import type {GetServerMaxUploadSize200} from './schemas/get-server-max-upload-size200';

import type {ImportRecordsIntoScoutBody} from './schemas/import-records-into-scout-body';

import type {ImportRecordsIntoScout200} from './schemas/import-records-into-scout200';

import type {ListSettings200} from './schemas/list-settings200';

import type {LoadMenuEditorConfig200} from './schemas/load-menu-editor-config200';

import type {LoadSeoTags200} from './schemas/load-seo-tags200';

import type {ValidateUploadBackendCredentialsBody} from './schemas/validate-upload-backend-credentials-body';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all settings
 */
export const listSettings = (
  options?: SecondParameter<typeof orvalApiFetch<ListSettings200>>,
) => {
  return orvalApiFetch<ListSettings200>(
    {url: `/settings`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update settings
 */
export const updateSettings = (
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>({url: `/settings`, method: 'POST'}, options);
};
/**
 * @summary Load SEO tags
 */
export const loadSeoTags = (
  options?: SecondParameter<typeof orvalApiFetch<LoadSeoTags200>>,
) => {
  return orvalApiFetch<LoadSeoTags200>(
    {url: `/settings/seo-tags`, method: 'GET'},
    options,
  );
};
/**
 * @summary Load menu editor config
 */
export const loadMenuEditorConfig = (
  options?: SecondParameter<typeof orvalApiFetch<LoadMenuEditorConfig200>>,
) => {
  return orvalApiFetch<LoadMenuEditorConfig200>(
    {url: `/settings/menu-editor-config`, method: 'GET'},
    options,
  );
};
/**
 * @summary Validate backend credentials
 */
export const validateUploadBackendCredentials = (
  validateUploadBackendCredentialsBody: ValidateUploadBackendCredentialsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/settings/uploading/validate-backend-credentials`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: validateUploadBackendCredentialsBody,
    },
    options,
  );
};
/**
 * @summary Get server max upload size
 */
export const getServerMaxUploadSize = (
  options?: SecondParameter<typeof orvalApiFetch<GetServerMaxUploadSize200>>,
) => {
  return orvalApiFetch<GetServerMaxUploadSize200>(
    {url: `/settings/server-max-file-size`, method: 'GET'},
    options,
  );
};
/**
 * @summary Get searchable models
 */
export const getSearchableModels = (
  options?: SecondParameter<typeof orvalApiFetch<GetSearchableModels200>>,
) => {
  return orvalApiFetch<GetSearchableModels200>(
    {url: `/admin/search/models`, method: 'GET'},
    options,
  );
};
/**
 * @summary Import records into scout
 */
export const importRecordsIntoScout = (
  importRecordsIntoScoutBody: ImportRecordsIntoScoutBody,
  options?: SecondParameter<typeof orvalApiFetch<ImportRecordsIntoScout200>>,
) => {
  return orvalApiFetch<ImportRecordsIntoScout200>(
    {
      url: `/admin/search/import`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: importRecordsIntoScoutBody,
    },
    options,
  );
};
export type ListSettingsResult = NonNullable<
  Awaited<ReturnType<typeof listSettings>>
>;
export type UpdateSettingsResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type LoadSeoTagsResult = NonNullable<
  Awaited<ReturnType<typeof loadSeoTags>>
>;
export type LoadMenuEditorConfigResult = NonNullable<
  Awaited<ReturnType<typeof loadMenuEditorConfig>>
>;
export type ValidateUploadBackendCredentialsResult = NonNullable<
  Awaited<ReturnType<typeof validateUploadBackendCredentials>>
>;
export type GetServerMaxUploadSizeResult = NonNullable<
  Awaited<ReturnType<typeof getServerMaxUploadSize>>
>;
export type GetSearchableModelsResult = NonNullable<
  Awaited<ReturnType<typeof getSearchableModels>>
>;
export type ImportRecordsIntoScoutResult = NonNullable<
  Awaited<ReturnType<typeof importRecordsIntoScout>>
>;
